import React from "react";
import { Container, Grid } from "@material-ui/core";

import "./create-documents.css";
import {
    SimpleLoading,
    HeaderHLPure,
    PromotionalFooterPure,
    ButtonAddHLPure,
    DialogSystemGLPure,
  } from "../../pures";

const CreateDocumentsView = (props) => {
  let {
    isLoadingView,
    t,
    showLoadingRequesting,
    toggleErrorRequesting,
    showCompletedRequesting,
    toggleLoadingRequesting,
    showErrorRequesting,
    toggleCompletedRequesting,
    messageError,
    tabs,
    currentPage,
    changeRoute,
  } = props;

  let Tab = tabs && tabs.length > 0 ? tabs[currentPage].component : null;
  let headerTitle =
    tabs && tabs.length > 0
      ? tabs[currentPage].header
      : t("digitalContractAction.routes.start.header");

  if (isLoadingView) return <SimpleLoading />;

  const handleChangePage = (route) => {
    let includeState = route === "standar-contracts" ? true : false;
    let state;
    if (includeState) {
      state = {
        standardContract: true,
      };
    }
    changeRoute(route, includeState, state);
  };

  return (
    <div className="standard-wrapper">
      <Container>
        <div className="digitalContractView-header">
          <HeaderHLPure title={headerTitle} />
        </div>
        <div className="digitalContractView-body">
          <div className="digitalContractView-menu-container">
            <div className="digitalContractView-menu-buttons">
              <ButtonAddHLPure
                nameBtn={t("digitalContractAction.new.document")}
                onClickBtn={() => handleChangePage("request-new-contract")}
                iconAdd
              />
            </div>
          </div>
          {Tab && (
            <Grid item xs={12} role="tabpanel" aria-expanded={true}>
              <Tab {...props} />
            </Grid>
          )}
        </div>
        <Grid item xs={12}>
          <PromotionalFooterPure />
        </Grid>
      </Container>
      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}
        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}
        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleErrorRequesting}
        messageError={messageError}
      />
    </div>
  );
};

export { CreateDocumentsView as default };
